import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get a team
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetTeam = packet => {
  return {
    type: 'REQUEST_GET_TEAM',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetTeamSuccess = data => ({
  type: 'RECEIVE_GET_TEAM_SUCCESS',
  data
})

export const receiveGetTeamFail = data => ({
  type: 'RECEIVE_GET_TEAM_FAIL',
  data
})

export const tryToGetTeam = packet => (dispatch, getState) => {

  dispatch(requestGetTeam(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/members/' + packet.kind + '/' + packet.id, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetTeamSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetTeamFail({errors:e, lastSubmit: packet}));
    })
}
